<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <b-form @submit="onSubmit" @reset="onReset" novalidate="novalidate">
                    <div class="card">
                        <div class="card-header card-header-icon card-header-rose">
                            <div class="card-icon" v-b-toggle.filter>
                                <i class="material-icons">search</i>
                            </div>
                            <h4 class="card-title">Filtros</h4>
                        </div>
                        <br />
                        <b-collapse id="filter">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form-group bmd-form-group is-filled">
                                            <label for="formalized_at" class="bmd-label-floating">Data da chegada da Venda no Pós venda</label>
                                            <date-picker
                                                range
                                                v-model="form.formalized_at"
                                                lang="pt-br"
                                                format="DD/MM/YYYY"
                                                placeholder="Escolha uma data"
                                                :not-after="form.end_at"
                                            ></date-picker>
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div
                                            class="form-group bmd-form-group"
                                            v-bind:class="{'is-filled': form.group != ''}"
                                            >
                                            <label form="group" class="bmd-label-floating">Grupo</label>
                                            <input
                                                refs="group"
                                                type="text"
                                                class="form-control"
                                                v-model="form.group"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div
                                            class="form-group bmd-form-group"
                                            v-bind:class="{'is-filled': form.quota != ''}"
                                            >
                                            <label form="quota" class="bmd-label-floating">Cota</label>
                                            <input
                                                refs="quota"
                                                type="text"
                                                class="form-control"
                                                v-model="form.quota"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div
                                            class="form-group bmd-form-group"
                                            v-bind:class="{'is-filled': form.physical_proposal != ''}"
                                            >
                                            <label form="physical_proposal" class="bmd-label-floating">Contrato</label>
                                            <input
                                                refs="physical_proposal"
                                                type="text"
                                                class="form-control"
                                                v-model="form.physical_proposal"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-2">
                                        <div
                                            class="form-group bmd-form-group"
                                            v-bind:class="{'is-filled': form.client != ''}"
                                            >
                                            <label form="client" class="bmd-label-floating">Cliente</label>
                                            <input
                                                refs="client"
                                                type="text"
                                                class="form-control"
                                                v-model="form.client"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div
                                            class="form-group bmd-form-group is-filled"
                                            >
                                            <label form="representative" class="bmd-label-floating">Representante</label>
                                            <model-list-select
                                                class="form-control"
                                                :list="representative"
                                                option-value="id"
                                                option-text="name"
                                                v-model="form.representative"
                                            ></model-list-select>
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div
                                            class="form-group bmd-form-group is-filled"
                                            >
                                            <label form="status" class="bmd-label-floating">Status</label>
                                            <model-list-select
                                                class="form-control"
                                                :list="after_sale_status"
                                                option-value="id"
                                                option-text="status"
                                                v-model="form.status"
                                            ></model-list-select>
                                        </div>
                                    </div>
                                    <div class="col-2">
                                        <div
                                            class="form-group bmd-form-group is-filled"
                                            >
                                            <label for="situation" class="bmd-label-floating">Situação</label>
                                            <model-list-select 
                                                class="form-control"
                                                :list="situations"     
                                                option-value="id"
                                                option-text="name"
                                                v-model="form.situation">
                                            </model-list-select>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group bmd-form-group">
                                            <b-form-checkbox id="show_me_all_for_me"
                                                            v-model="form.show_me_all_for_me"
                                                            value="1"
                                                            unchecked-value="0">
                                                Exibir todas as minhas pós vendas<br />
                                                <small class="error">Exibir pós vendas que foram respondidas e estão com outro usuário</small>
                                            </b-form-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer">
                                <button type="reset" class="btn btn-fill btn-outline-danger">Limpar</button>
                                <button type="submit" class="btn btn-fill btn-rose">Filtrar</button>
                            </div>
                        </b-collapse>
                    </div>
                </b-form>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">list</i>
                        </div>
                        <h4 class="card-title ">Lista</h4>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Contrato</th>
                                        <th>Grupo</th>
                                        <th>Cota</th>
                                        <th width="100px">Cliente</th>
                                        <th width="30px">CPF/CNPJ</th>
                                        <th>Status</th>
                                        <th>Situação</th>
                                        <th>Representante</th>
                                        <th width="100px">Data de Chegada no Pós venda</th>
                                        <th class="text-right">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-show="after_sales.length > 0"
                                        v-for="iterator in after_sales"
                                        :key="iterator.id">
                                        <td class="text-center">{{ iterator.physical_proposal }}</td>
                                        <td>{{ iterator.group }}</td>
                                        <td>{{ iterator.quota }}</td>
                                        <td>{{ iterator.client.name }}</td>
                                        <td>{{ iterator.client.cpf_cnpj }}</td>
                                        <td class="text-center" v-if="iterator.status != null">{{ iterator.status.status }}</td>
                                        <td class="text-center" v-else>Sem status</td>
                                        <td class="text-center">{{ iterator.situation == 'A' ? 'Alocada' : (iterator.situation == 'C' ? 'Cancelada' : 'Não alocada') }}</td>
                                        <td>{{ iterator.representative.name }}</td>
                                        <td class="text-center">{{ iterator.formalized_at | moment('DD/MM/YYYY') }}</td>
                                        <td class="td-actions text-right">
                                            <b-button-group>
                                                <router-link
                                                    data-original-title
                                                    title="Histórico de pós venda do contrato"
                                                    class="btn btn-outline-primary btn-link"
                                                    tag="button"
                                                    :to="{
                                                        name: 'after_sales.history', 
                                                        params: {
                                                            id: iterator.id
                                                        }, 
                                                        query: $route.query
                                                    }"
                                                    >
                                                    <i class="material-icons">find_in_page</i>
                                                </router-link>
                                                <router-link
                                                    data-original-title
                                                    title="Editar Informações e interações da formalização de contrato"
                                                    class="btn btn-block btn-sm btn-outline-primary"
                                                    tag="button"
                                                    :to="{
                                                        name: 'after_sales.edit', 
                                                        params: {
                                                            id: iterator.id
                                                        }, 
                                                        query: $route.query
                                                    }"
                                                    >
                                                    <i class="fa fa-thumbs-up" />
                                                </router-link>
                                            </b-button-group>
                                        </td>
                                    </tr>
                                    <tr v-show="after_sales.length==0">
                                        <td colspan="7">Nenhuma pós venda encontrada!</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="card-footer" v-show="after_sales.length">
                        <div class="row" style="width:100%;">
                            <div class="col-sm-4">
                                <model-list-select
                                    class="form-control"
                                    :list="limits"
                                    option-value="limit"
                                    option-text="text"
                                    v-model="limit"
                                    @input="onSubmit($event)"
                                ></model-list-select>
                            </div>
                            <div class="col-sm-4 text-center">
                                <b-pagination
                                order="is-right"
                                v-show="after_sales.length > 0"
                                v-model="currentPage"
                                :simple="false"
                                :per-page="limit"
                                :total-rows="total"
                                @change="pageChange"
                                ></b-pagination>
                            </div>
                            <div class="col-sm-4 text-right text-secondary">
                                {{ to }} registros de {{ total }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal
        ref="modal"
        dialog-class="modal-lg"
        hide-footer
        scrollable
        :visible="$route.meta.showModal"
        :title="$route.meta.title"
        @hide="hideModal"
        >
        <router-view name="modal" />
        </b-modal>
    </div>
</template>
<script>
    import FiltersSearch from './Filters';
    import Vue from "vue";
    export default {
        components : { FiltersSearch },
        computed: {
            after_sales() {
                console.log(this.$store.state.after_sales.itens.data)
                return this.$store.state.after_sales.itens.data != undefined ? this.$store.state.after_sales.itens.data : [];
            },
            after_sale_status() {
                return this.$store.state.after_sale_status.itens;
            },
            representative() {
                var salesmans = [
                    {
                        id: "",
                        name: "Todos"
                    }
                ];
                return salesmans.concat(this.$store.state.users.salesmans);
            }
        },
        created: function () {
            this.$root.$on("hideModal", () => {
                this.$refs.modal.hide();
            });
            this.$root.$on("updateList", () => {
                this.initQueryString();
            });
            this.initQueryString();
        },
        data() {
            return {
                currentPage: 1,
                form: {
                    client: '',
                    end_at: Vue.moment(),
                    formalized_at: [Vue.moment().subtract(30, "days"), Vue.moment()],
                    representative: 0,
                    physical_proposal: '',
                    group: '',
                    quota: '',
                    show_me_all_for_me: 0,
                    situation: 'A',
                    status: ''
                },
                limit: 0,
                limits : [
                    { limit : 5, text : 'Exibir 5(cinco) por página' },
                    { limit : 10, text : 'Exibir 10(dez) por página' },
                    { limit : 25, text : 'Exibir 25(vinte e cinco) por página' },
                    { limit : 50, text : 'Exibir 50(cinquenta) por página' },
                ],
                situations: [
                    {
                        id: "A",
                        name: "Alocada"
                    },
                    {
                        id: "C",
                        name: "Cancelada"
                    },
                    {
                        id: "N",
                        name: "Não alocada"
                    },
                    {
                        id: "T",
                        name: "Todas"
                    }
                ],
                textSearch : '',
                items : [],
                total: 0,
                to : 0
            };
        },
        methods: {
            hideModal() {
                this.$router.go(-1);
            },
            _refreshData() {
                this.getData();
            },
            async getData() {
                var self = this;
                var params = {
                    limit: self.limit,
                    currentPage: self.currentPage,
                    params: self.form
                }

              self.$root.$emit('onLoading');
              const response = self.$store.dispatch('after_sales/all', params);

              response.then(function (_pagination) {
                  self.total = _pagination.total;
                  self.to = _pagination.to;
                  self.$root.$emit('onLoading');
                  self.getDataAfterSaleStatus();
              });

              response.catch(function () {
                  self.$root.$emit('onLoading');
                  self.getDataAfterSaleStatus();
              });
          },
          async getDataAfterSaleStatus() {
              var self = this;

              self.$root.$emit('onLoading');
              const response = self.$store.dispatch('after_sale_status/all');

                response.then(function () {
                    self.$root.$emit('onLoading');
                    self.getSalesmans();
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                    self.getSalesmans();
                });
            },
            async getSalesmans() {
                var self = this;

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('users/getSalesmans', {all_users:true});

                response.then(() => {
                    self.$root.$emit('onLoading');
                });

                response.catch(() => {
                    self.$root.$emit('onLoading');
                });
            },
            initQueryString() {
                var self = this;
                var query = self.$route.query;

              self.limit = 25;

                if (query.limit) {
                    self.limit = parseInt(query.limit);
                }
                if (query.currentPage) {
                    setTimeout(function(){
                        self.pageChange(parseInt(query.currentPage));
                    }, 900);
                }
                if (query.formalized_at && query.formalized_at.length == 2) {
                    self.form.formalized_at = [
                        Vue.moment(query.formalized_at[0]),
                        Vue.moment(query.formalized_at[1])
                    ];
                }
                if (query.client) {
                    self.form.client = query.client
                }
                if (query.representative) {
                    self.form.representative = query.representative
                }
                if (query.physical_proposal) {
                    self.form.physical_proposal = query.physical_proposal
                }
                if (query.group) {
                    self.form.group = query.group
                }
                if (query.quota) {
                    self.form.quota = query.quota
                }
                if (query.status) {
                    self.form.group = query.status
                }
                if (query.show_me_all_for_me) {
                    self.form.show_me_all_for_me = query.show_me_all_for_me
                }

              self.getData()
          },
          pageChange(_pageNum) {
              var self = this;

              self.currentPage = _pageNum

              self.setQueryString();

                self.getData();
            },
            async onReset() {
                var self = this;
                self.form = {
                    client: '',
                    end_at: Vue.moment(),
                    formalized_at: [Vue.moment().subtract(30, "days"), Vue.moment()],
                    physical_proposal: '',
                    representative: 0,
                    group: '',
                    quota: '',
                    status: ''
                };
                this._refreshData()
            },
            onSubmit(_ev=null) {
                if(isNaN(_ev))
                    _ev.preventDefault();

              var self = this;

              self.setQueryString();

              self.getData();
          },
          setQueryString() {
              var self = this;

                self.$router.push({
                    name: "after_sales.index",
                    query: {
                        limit: self.limit ? self.limit : 5,
                        currentPage: self.currentPage,
                        client: self.form.client,
                        formalized_at: [
                            Vue.moment(self.form.formalized_at[0]).format('YYYY-MM-DD'),
                            Vue.moment(self.form.formalized_at[1]).format('YYYY-MM-DD')
                        ],
                        group: self.form.group,
                        physical_proposal: self.form.physical_proposal,
                        quota: self.form.quota,
                        representative: self.form.representative,
                        status: self.form.status,
                        show_me_all_for_me: self.form.show_me_all_for_me
                    }
                })
            }
        }
    }
</script>
